import { IconDefinition } from '@ant-design/icons-angular';

export const ItalicOutline: IconDefinition = {
    name: 'italic',
    theme: 'outline',
    icon: '<svg viewBox="64 64 896 896" focusable="false"><path d="M798 160H366c-4.4 0-8 3.6-8 8v64c0 4.4 3.6 8 8 8h181.2l-156 544H229c-4.4 0-8 3.6-8 8v64c0 4.4 3.6 8 8 8h432c4.4 0 8-3.6 8-8v-64c0-4.4-3.6-8-8-8H474.4l156-544H798c4.4 0 8-3.6 8-8v-64c0-4.4-3.6-8-8-8z" /></svg>'
}